<template>
  <div id="datatable-process-primary-column">
    <div
      class="d-flex align-items-center"
      style="gap: .5rem"
      :class="{ 'justify-content-between': isBoxMode }"
    >
      <div
        class="d-flex flex-column align-items-start mr-2"
        :class="{ 'p-3': isBoxMode }"
      >
      {{value.status.id}}
        <span class="mb-2" :class="{ 'text-box-container': isBoxMode }">{{ value.name }}</span>
        <b-badge variant="info" class="pt-1"  :class="`process-status-button color-${value.status.id}`">{{ value.status.name }}</b-badge>
      </div>
      <div class="d-flex" style="gap: .75rem" :class="{ 'align-self-start px-3': isBoxMode }">
        <CommentsIcon
          :id="value.id"
          v-bind="comments"
        />
        <MovementsIcon
          :id="value.id"
          v-bind="movements"
        />
        <TagsIcon
          :id="value.id"
          v-bind="tags"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import CommentsIcon from './components/CommentsIcon'
import MovementsIcon from './components/MovementsIcon'
import TagsIcon from './components/TagsIcon'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    comments: {
      type: Object
    },
    movements: {
      type: Object
    },
    tags: {
      type: Object,
      default: () => {}
    },
    isBoxMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CommentsIcon,
    MovementsIcon,
    TagsIcon
  }
}
</script>

<style lang="sass">
#datatable-process-primary-column
  .text-box-container
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    line-clamp: 2
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
  .column-action-button
    width: 27px
    height: 27px
    border-radius: 50%
    padding: 4px
.datatables-comments-popover
  width: 400px
  max-width: 400px
  max-height: 400px
  .no-comments
    height: 335px
  .scroll
    height: calc(400px - 55px - 1.5rem)
    overflow-y: auto
    margin: 2px 0
    &:hover
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: transparent
    &::-webkit-scrollbar-thumb:hover
      background: #555
  .datetime-text
    font-size: .7rem
  #comments-message
    blockquote
      padding-left: 1rem
      border-left: 2px solid rgba(13, 13, 13, 0.1)

.process-status-button.color-1, .process-status-button:hover.color-1
  background-color: #007bff

.process-status-button.color-5, .process-status-button:hover.color-5
  background-color: #6FB200
  color: black

.process-status-button.color-3, .process-status-button:hover.color-3
  background-color: #6FB200

.process-status-button.color-6, .process-status-button:hover.color-6
  background-color: cadetblue

.process-status-button.color-7, .process-status-button:hover.color-7
  background-color: green

.process-status-button.color-8, .process-status-button:hover.color-8
  background-color: #ABABD4

.process-status-button.color-9, .process-status-button:hover.color-9
  background-color: #5F1F7B

.process-status-button.color-10, .process-status-button:hover.color-10
  background-color: red

.process-status-button.color-11, .process-status-button:hover.color-11
  background-color: #97077D
  color: black

.process-status-button.color-12, .process-status-button:hover.color-12
  background-color: teal

.process-status-button.color-13, .process-status-button:hover.color-13
  background-color: tomato

.process-status-button.color-14, .process-status-button:hover.color-14
  background-color: #132C7A

.process-status-button.color-15, .process-status-button:hover.color-15
  background-color: #00872A

.process-status-button.color-16, .process-status-button:hover.color-16
  background-color: #132C7A

.process-status-button.color-9999, .process-status-button:hover.color-9999
  background-color: orange
</style>
